import { createContext, useContext, useMemo } from 'react';

/**
 * Límite para los Tooltip de Meta dentro de un contenedor angosto (bloque «Campañas» de la
 * ficha): sin él se cortaban contra el borde del panel. Quien lo provee pasa el nodo del
 * contenedor; sin provider (panel de Meta Ads) los Tooltip quedan como siempre.
 */
export const MetaTooltipBoundaryContext = createContext(null);

/**
 * Props de MUI Tooltip (v6, `slotProps.popper`) con `preventOverflow` + `flip` contra `boundary`.
 * Sin `boundary` → `{}` (sin cambios).
 *
 * @param {Element|null} boundary
 */
export function metaTooltipBoundaryProps(boundary) {
  if (!boundary) return {};
  return {
    slotProps: {
      popper: {
        modifiers: [
          { name: 'preventOverflow', options: { boundary, altAxis: true, tether: false, padding: 8 } },
          { name: 'flip', options: { boundary, padding: 8, fallbackPlacements: ['bottom', 'top'] } },
        ],
      },
    },
  };
}

/** Props para el Tooltip según el límite del contexto (memo por nodo). */
export function useMetaTooltipProps() {
  const boundary = useContext(MetaTooltipBoundaryContext);
  return useMemo(() => metaTooltipBoundaryProps(boundary), [boundary]);
}
